import React, { useContext, useEffect } from 'react';
import { ProductContext } from '../context/ProductContext.js';
import { useLocation } from 'react-router-dom';
import "../assest/SearchResults.css";
import { FavoriteContext } from '../context/FavoriteContext.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as SolidHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as RegularHeart } from '@fortawesome/free-regular-svg-icons';
import { useImage } from "../context/ImageContext.js";

const SearchResults = () => {
  const { getImageUrl } = useImage();
  const location = useLocation();
  const query = new URLSearchParams(location.search).get('query');
  const { state, searchProducts } = useContext(ProductContext);
  const { favorites, addToFavorite, removeFavorite, loadFavorites } = useContext(FavoriteContext);

  useEffect(() => {
    if (query) {
      searchProducts(query);
    }
  }, [query, searchProducts]);

  useEffect(() => {
    loadFavorites();
  }, []);

  const isFavorite = (product) => {
    return favorites.some(favProduct =>
      String(favProduct.urun_id) === String(product.id)
    );
  };

  const handleFavoriteToggle = async (event, product) => {
    event.stopPropagation();
    event.preventDefault();

    try {
      if (isFavorite(product)) {
        const favoriteProduct = favorites.find(fav =>
          String(fav.urun_id) === String(product.id)
        );
        if (favoriteProduct) {
          await removeFavorite(favoriteProduct);
        }
      } else {
        await addToFavorite(product);
      }
    } catch (error) {
      console.error('Favori işlemi sırasında hata:', error);
    }
  };
  fbq('track', 'Search');

  return (
    <div className='search'>

      <h2 className='search-results-title py-3'>"{query}" için arama sonuçları</h2>
      <div className="search-result">

        {state.searchs.length === 0 ? (
          <p className='no-results'>Sonuç bulunamadı</p>
        ) : (
          <div className="search-result-product">

            <div className="search-result-grid">

              {state.searchs.map((product, index) => (
                <a
                  key={`${product.id}-${index}`}
                  href={`/urun/${product.sef}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="search-result-card"
                  style={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
                >
                  <div className="search-result-img-container">

                    <img
                      src={getImageUrl(product.image.i1)}
                      alt={product.name} onError={(e) => {
                        e.target.onerror = null;
                      }}
                    />
                    {product.eski_fiyat !== product.fiyat && (
                      <div className="discount-badge">
                        {/* {Math.floor(((product.eski_fiyat - product.fiyat) / product.eski_fiyat) * 100)}% */}
                        <div className='d-flex flex-column'>
                          {(((product.eski_fiyat - product.fiyat) / product.eski_fiyat) * 100).toFixed(1)}%
                          <span>İndirim</span>
                        </div>
                      </div>
                    )}
                    <div
                      onClick={(e) => handleFavoriteToggle(e, product)}
                      className="favorite-iconn d-flex"
                    >
                      <FontAwesomeIcon
                        icon={isFavorite(product) ? SolidHeart : RegularHeart}
                        style={{ color: isFavorite(product) ? 'red' : 'gray', fontSize: '22px' }}
                      />
                    </div>
                  </div>
                  <div className="search-result-responsive-info px-2">
                    <h3 className="search-result-responsive-name text-start fw-bold fs-6 fs-7">
                      {product.baslik}
                    </h3>
                    <div className="rating text-start">
                      {'★'.repeat(5)}
                    </div>
                    <div className="pricee flex-row gap-md-2 gap-1">
                      {product.fiyat && product.eski_fiyat !== product.fiyat ? (
                        <>
                          <p className="old-price mb-0" style={{ textDecoration: 'line-through' }}>
                            {product.eski_fiyat.toLocaleString('tr-TR')} TL
                          </p>
                          <p className="discountedd-price">
                            {product.fiyat.toLocaleString('tr-TR')} TL
                          </p>
                        </>
                      ) : (
                        <p className="originall-price p-0">
                          {product.fiyat.toLocaleString('tr-TR')} TL
                        </p>
                      )}
                    </div>
                    {!product.image.i1 && <p>Ürün fotoğrafı bulunamadı.</p>}
                  </div>
                </a>
              ))}
            </div>
          </div>

        )}
      </div>
    </div>

  );
};

export default SearchResults;